import Image from 'next/image';

import { fontStyles } from '@/styles/typography';

import { StyledPrimaryCell, StyledH2 } from '../utils';

export const getImage = (num: number) => `/images/crosschain/traders/traderIcon${num}.png`;

const userProfilesItems = [
  {
    url: getImage(1),
    label: 'NFT and token hunters',
  },
  {
    url: getImage(2),
    label: 'APY farmers',
  },
  {
    url: getImage(3),
    label: 'Portfolio managers',
  },
  {
    url: getImage(4),
    label: 'L2 early movers',
  },
  {
    url: getImage(5),
    label: 'New-app adopters',
  },
];

export const UsersProfilesSection = () => {
  return (
    <StyledPrimaryCell className="flex flex-col items-center text-center py-16 bg-[url(/images/crosschain/wave-left-lines-mobile.svg)_no-repeat_left_100%,_url(/images/crosschain/wave-right-lines-mobile.svg)_no-repeat_right_100%,_var(--token-gray-100)] tablet:bg-[url(/images/crosschain/wave-left-lines.svg)_no-repeat_left_100%,_url(/images/crosschain/wave-right-lines.svg)_no-repeat_right_100%,_var(--token-gray-100)]">
      <StyledH2>
        For traders who
        <span className={fontStyles({ variant: 'H2', className: 'mb-0 text-token-gray-700 grid' })}>
          want the most out of DeFi
        </span>
      </StyledH2>
      <ul className="flex flex-col tablet:flex-row tablet:flex-wrap tablet:justify-evenly desktop:justify-around mt-10 desktop:mt-18 desktop:w-[952px]">
        {userProfilesItems.map(({ label, url }) => (
          <li
            className="flex flex-col items-center text-token-gray-800 text-center mb-12 tablet:mb-7 tablet:first:relative tablet:first:left-[12%] tablet:first:flex-[50%] tablet:nth-[2]:relative tablet:nth-[2]:right-[10%] tablet:nth-[2]:flex-[50%] desktop:mb-0 desktop:nth-[n]:static desktop:nth-[n]:flex-none desktop:nth-[1]:mt-12 desktp:nth-[2]:mt-3 desktop:nth-[5]:mt-12"
            key={label}
          >
            <Image
              src={url}
              className="mb-4 stroke-token-gray-100 transform translate-z-0 backface-hidden"
              height={69}
              width={73}
              alt=""
              style={{
                filter:
                  'drop-shadow(0px 4px 42px rgba(0, 0, 0, 0.06)) drop-shadow(0px 5.000000476837158px 6px rgba(0, 0, 0, 0.08))',
              }}
            />
            <p className="min-w-max">{label}</p>
          </li>
        ))}
      </ul>
    </StyledPrimaryCell>
  );
};
